import { FC } from "react";
import DontUseSvg from "../../public/icons/dontuse.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const UsageDontUseIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><DontUseSvg/></span>;
